import { Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import PropTypes from 'prop-types';
import Input from 'components/atoms/input';

const AccountInfo = ({ errors }) => {
  const accountInfo = [...forms.adminPanelsUser.userAdd.accountInfo];
  return (
    <div className="admin-patient-form-block">
      <span>Account Info</span>
      <Row>
        {accountInfo.map((field) => (
          <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
            <Input {...field} dataCy={`${field.id}-input`} />
            {errors[field.id] ? (
              <div className="input-error">{errors[field.id]}</div>
            ) : null}
          </Col>
        ))}
      </Row>
    </div>
  );
};

AccountInfo.propTypes = {
  errors: PropTypes.shape(),
};

export default AccountInfo;
